type I18nShape = {
  formatMessage: (descriptor: { id: string }, values?: Record<string, string>) => string
}

export const formatGuests = (
  adults: number | string,
  children: number | string,
  i18n: I18nShape,
  rooms: number
) => {
  const adultsNumber = Number(adults)
  const childrenNumber = Number(children)
  const roomsLabel = rooms > 1 ? `(x${rooms}) ` : ''

  if (!adultsNumber && !childrenNumber) return ''

  const parts = [
    adultsNumber > 0 &&
      `${roomsLabel}${adultsNumber} ${i18n.formatMessage({
        id: adultsNumber === 1 ? 'global.adult' : 'global.adults',
      })}`,
    childrenNumber > 0 &&
      `${childrenNumber} ${i18n.formatMessage({
        id: childrenNumber === 1 ? 'global.child' : 'global.children',
      })}`,
  ]

  return parts.filter(Boolean).join(' · ')
}
